module.exports = __webpack_public_path__ + "static/media/Signup.0a1fbef4.png";